<div *ngIf="vm$ | async as vm" class="min-h-0 h-full">
	<ng-container *ngIf="!vm.loadingForm">
		<div
			class="flex min-h-0 h-[70vh] border border-gray-200 rounded-xl"
			*ngIf="vm.forms?.length; else noForms"
		>
			<div class="basis-1/3 min-h-0 h-full overflow-hidden flex flex-col">
				<div class="flex flex-col border-b max-h-full">
					<div class="flex justify-between items-center p-4 border-b">
						<span
							class="h5 truncate"
							title="Your Uploads ({{ vm.uploadedDocuments.length }})"
							>Your Uploads ({{ vm.uploadedDocuments.length }})</span
						>
						<ui-button
							icon="upload"
							preset="MEDIUM_EMPHASIS"
							size="sm"
							label="Upload Document"
							(click)="uploadDocument()"
						></ui-button>
					</div>
					<div
						class="flex flex-col divide-y h-md:max-h-20 h-lg:max-h-32 h-xl:max-h-48 flex-1 overflow-y-scroll"
					>
						<div
							*ngFor="let uploadedDoc of vm.uploadedDocuments"
							class="flex group gap-4 px-4 py-2 justify-between items-center cursor-pointer text-gray-500 duration-300"
							[ngClass]="
								uploadedDoc.url === vm.uploadedDocumentUrl
									? 'bg-violet-50'
									: 'hover:bg-gray-50 text-gray-700'
							"
							(click)="selectUploadedDocument(uploadedDoc)"
						>
							<span
								class="flex-1 duration-300 truncate text-sm font-medium text-gray-600"
								[ngClass]="{
									'text-gray-950 font-medium':
										uploadedDoc.url === vm.uploadedDocumentUrl,
								}"
								>{{ uploadedDoc.name }}</span
							>
							<app-button
								[holdable]="true"
								btn="none"
								size="small"
								class="group-hover:block hidden"
								cssClasses="border-0 border-none"
								[icon]="ICON.DELETE"
								(onClick)="deleteUploadedDocument(uploadedDoc?.id)"
								*ngIf="isUndeletableUserUploadedDoc(uploadedDoc?.id)"
							></app-button>
							<app-checkbox
								type="clear"
								[(ngModel)]="uploadedDoc.selected"
								(ngModelChange)="calculateSelectedTotal($event)"
							></app-checkbox>
						</div>
					</div>
				</div>
				<div class="min-h-0 flex flex-col max-h-full">
					<div class="px-4 py-2 border-b border-t-2">
						<h5 class="h5 pb-1">
							{{ vm.lenderName }} Form Library ({{ vm.forms?.length }})
						</h5>
						<div class="flex">
							<p
								class="p-sm truncate"
								title="Forms Last Verified by Sync Team {{
									vm.lenderFormLastCheckedAt | date: 'MMMM y'
								}}"
							>
								Forms Last Verified by Sync Team
								{{ vm.lenderFormLastCheckedAt | date: 'MMMM y' }}
							</p>
							<app-icon
								class="ml-2"
								[icon]="ICON.INFO"
								matTooltip="The Sync team will regularly check the lender's site to ensure forms are up-to-date."
							></app-icon>
						</div>
					</div>
					<div
						class="flex flex-col divide-y overflow-y-scroll max-h-full flex-1"
					>
						<div
							*ngFor="let form of vm.forms"
							class="flex gap-4 px-4 py-2 justify-between items-center cursor-pointer text-gray-500 duration-300"
							[ngClass]="
								form?.id === vm.selectedForm?.id
									? 'bg-violet-50'
									: 'hover:bg-gray-50 text-gray-700'
							"
							(click)="selectForm(form.context.id)"
						>
							<div>
								<h6
									class="flex-1 duration-300 text-sm font-medium text-gray-600"
									[ngClass]="{
										'text-gray-950 font-medium':
											form?.context?.id === vm.selectedForm?.context?.id,
									}"
								>
									{{ form.name }}
									<ui-pill
										[type]="PILL_TYPES.NEW"
										*ngIf="
											(_mortgage?.type !== matterMortgageType.CLOSER_SYNC ||
												form.doesExpiryDateApplyToSync) &&
											form.newFlagExpiryDate > currentDate
										"
									></ui-pill>
								</h6>
								<p *ngIf="vm.packageFiles[form.id]?.createdAt" class="p-xs">
									Last sent: {{ vm.packageFiles[form.id].createdAt | date }}
								</p>
							</div>
							<app-checkbox
								type="clear"
								[(ngModel)]="form.selected"
								(ngModelChange)="calculateSelectedTotal($event)"
							></app-checkbox>
						</div>
					</div>
				</div>
				<div class="flex flex-col shrink-0 min-h-0 gap-2 p-4 shadow mt-auto">
					<ui-button
						icon="download"
						[loading]="vm.downloading"
						[disabled]="vm.selectedCount === 0"
						[style]="vm.isLawyerConnected ? 'outline' : 'solid'"
						[fullWidth]="true"
						[label]="'Download (' + vm.selectedCount + ')'"
						(click)="downloadFiles()"
					></ui-button>
					<ui-button
						[icon]="
							vm.syncFlowType === SYNC_FLOW_TYPES.EMAIL ? 'download' : 'send-2'
						"
						[matTooltip]="
							disableSendToLender
								? _mortgage?.syncFlowType === SYNC_FLOW_TYPES.EMAIL ||
									syncFlowType === SYNC_FLOW_TYPES.EMAIL
									? 'You are missing funding details. Please fill out the ‘Funding Options’ sections in the general tab to sign and download forms.'
									: 'You are missing funding details. Please fill out the ‘Funding Options’ sections in the general tab to send documents to the lender.'
								: vm.selectedCount === 0
									? _mortgage?.syncFlowType === SYNC_FLOW_TYPES.EMAIL ||
										syncFlowType === SYNC_FLOW_TYPES.EMAIL
										? 'You need to select a document or form to download.'
										: 'You need to select a document or form to send to the lender.'
									: null
						"
						[disabled]="vm.selectedCount === 0 || disableSendToLender"
						[fullWidth]="true"
						[label]="
							vm.syncFlowType === SYNC_FLOW_TYPES.EMAIL
								? 'Sign & Download'
								: 'Send to Lender (' + vm.selectedCount + ')'
						"
						(click)="sendToLender()"
						*ngIf="vm.isLawyerConnected; else connectToSyncSection"
					></ui-button>
					<ng-template #connectToSyncSection>
						<div class="text-center text-sm pt-2">
							Unlock digital document signing with Sync!
						</div>
						<ui-button
							[style]="'outline'"
							label="Connect to Sync"
							[fullWidth]="true"
							icon="plug"
							(click)="connectToSync()"
						/>
					</ng-template>
				</div>
			</div>
			<div class="basis-2/3">
				<div class="flex flex-col h-full">
					<div
						class="bg-gray-50 border border-gray-100 text-sm flex w-full items-center justify-center text-grey p-2 rounded-t-md"
					>
						<p>
							<span><app-icon [icon]="ICON.INFO"></app-icon></span> Any Updates
							Here Will Not Be Reflected On File
						</p>
					</div>
					<app-matter-form-instance-viewer
						[googleSrcUrl]="vm.uploadedDocumentUrl"
						[form]="vm.selectedForm"
						class="w-full h-full"
					/>
				</div>
			</div>
		</div>
		<ng-template #noForms>
			<app-closer-sync-missing-documents
				[lender]="(_mortgage.lenders | keyvalue)?.[0]?.value"
			/>
		</ng-template>
	</ng-container>
</div>
